import { appProvidersMap } from './providersMap';

export const ComponentProviders = ({ children, providersMap }) =>
  Object.values({ ...appProvidersMap, ...providersMap })
    .reverse() // apply providers top to bottom
    .reduce((memo, Provider) => <Provider>{memo}</Provider>, children);
